module.exports = __webpack_public_path__ + "img/default.4b6b0861.png";